import { C as x, H as E, o, w as R } from "./opencv-helper-DBi3yyo6.js";
import { O as w } from "./one-euro-filter-CZuIcz4a.js";
class C {
  constructor() {
    this.poseLandmarker = null, this.vision = null, this.initPromise = null, this.lastVideoTime = -1, this.runningMode = "VIDEO";
  }
  async init() {
    return this.initPromise ? this.initPromise : (this.initPromise = (async () => {
      try {
        this.vision = await x.forVisionTasks(
          "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.9/wasm"
        ), await this._createPoseLandmarker();
      } catch (e) {
        throw console.error("Error initializing PoseMeshHelper:", e), this.initPromise = null, e;
      }
    })(), this.initPromise);
  }
  async _createPoseLandmarker() {
    if (this.poseLandmarker) {
      try {
        await this.poseLandmarker.close();
      } catch (e) {
        console.warn("Error closing previous PoseLandmarker:", e);
      }
      this.poseLandmarker = null, await new Promise((e) => setTimeout(e, 100));
    }
    this.poseLandmarker = await E.createFromOptions(this.vision, {
      baseOptions: {
        modelAssetPath: "https://storage.googleapis.com/mediapipe-models/pose_landmarker/pose_landmarker_heavy/float16/1/pose_landmarker_heavy.task",
        delegate: "GPU"
      },
      runningMode: this.runningMode,
      numPoses: 1
    });
  }
  async detect(e) {
    var t, s, i;
    if (!this.poseLandmarker) {
      console.warn("PoseLandmarker not initialized, attempting to initialize...");
      try {
        await this.init();
      } catch (r) {
        return console.error("Failed to initialize PoseLandmarker:", r), null;
      }
    }
    if (!e || !e.videoWidth || !e.videoHeight)
      return null;
    if (e.currentTime !== this.lastVideoTime)
      try {
        const r = performance.now(), a = await this.poseLandmarker.detectForVideo(e, r);
        return this.lastVideoTime = e.currentTime, (t = a.landmarks) != null && t[0] ? {
          landmarks: a.landmarks[0],
          worldLandmarks: a.worldLandmarks[0]
        } : null;
      } catch (r) {
        if (console.error("Pose detection error:", r), (s = r.message) != null && s.includes("Graph has errors") || (i = r.message) != null && i.includes("timestamp mismatch")) {
          console.log("Attempting to recover from graph error...");
          try {
            await new Promise((a) => setTimeout(a, 200)), await this._createPoseLandmarker();
          } catch (a) {
            console.error("Failed to recover from graph error:", a);
          }
        }
        return null;
      }
  }
}
const k = [0, 11, 12, 23, 24];
class S {
  constructor(e) {
    const i = e.videoWidth || e.width, r = e.videoHeight || e.height, a = i, n = 2 * Math.atan(r / (2 * a)), d = 2 * 1 * Math.tan(0.5 * n), c = i * d / r;
    this.near = 1, this.far = 1e4, this.frameWidth = i, this.frameHeight = r, this.focalLength = a, this.fov = n, this.left = -0.5 * c, this.right = 0.5 * c, this.bottom = -0.5 * d, this.top = 0.5 * d, this.center = [i / 2, r / 2], this.cameraMatrix = o.matFromArray(3, 3, o.CV_64F, [
      a,
      0,
      this.center[0],
      0,
      a,
      this.center[1],
      0,
      0,
      1
    ]), this.distCoeffs = o.Mat.zeros(4, 1, o.CV_64F);
  }
  getCameraParams() {
    return {
      fov: this.fov * 180 / Math.PI,
      aspect: this.frameWidth / this.frameHeight,
      near: this.near,
      far: this.far
    };
  }
  release() {
    this.cameraMatrix && (this.cameraMatrix.delete(), this.cameraMatrix = null), this.distCoeffs && (this.distCoeffs.delete(), this.distCoeffs = null);
  }
  // normalizedLandmarks: [[x,y,z], ...] in 0-1 screen space (MediaPipe NormalizedLandmarks)
  // Mirrors the face-target estimator's coordinate pipeline so near=1 is always safe.
  estimate(e) {
    const t = this._projectToScreen(e);
    let s = this._cloneLandmarks(t);
    this._changeHandedness(s);
    const i = t.reduce((h, g) => h + g[2], 0) / t.length, r = this._estimateScale(s);
    s = this._cloneLandmarks(t), this._moveAndRescaleZ(i, r, s), this._unprojectScreen(s), this._changeHandedness(s);
    const a = this._estimateScale(s);
    let n = this._cloneLandmarks(t);
    const d = r * a;
    if (!Number.isFinite(d) || d < 1e-6) return null;
    this._moveAndRescaleZ(i, d, n), this._unprojectScreen(n), this._changeHandedness(n);
    let c = null, l = null, f = null, u = null, p = null;
    try {
      const h = [], g = [];
      for (const P of k) {
        const _ = n[P];
        h.push(_[0], _[1], _[2]), g.push(
          e[P][0] * this.frameWidth,
          e[P][1] * this.frameHeight
        );
      }
      c = o.matFromArray(k.length, 3, o.CV_64F, h), l = o.matFromArray(k.length, 2, o.CV_64F, g), f = new o.Mat(3, 1, o.CV_64F), u = new o.Mat(3, 1, o.CV_64F), p = new o.Mat(3, 3, o.CV_64F), o.solvePnP(c, l, this.cameraMatrix, this.distCoeffs, f, u, !1, 1), o.Rodrigues(f, p);
      const m = p.data64F, M = u.data64F, L = [
        m[0],
        m[1],
        m[2],
        M[0],
        -m[3],
        -m[4],
        -m[5],
        -M[1],
        -m[6],
        -m[7],
        -m[8],
        -M[2],
        0,
        0,
        0,
        1
      ], y = this._estimateScale(n);
      return { metricLandmarks: n, poseMatrix: L, poseScale: y };
    } catch (h) {
      return console.warn("PoseEstimator.estimate failed:", h), null;
    } finally {
      c == null || c.delete(), l == null || l.delete(), f == null || f.delete(), u == null || u.delete(), p == null || p.delete();
    }
  }
  // Shoulder width as scale reference (landmarks 11 & 12)
  _estimateScale(e) {
    const t = e[11], s = e[12];
    return !t || !s ? 1 : Math.sqrt((s[0] - t[0]) ** 2 + (s[1] - t[1]) ** 2 + (s[2] - t[2]) ** 2);
  }
  // Map normalized [0,1] coords → near-plane screen coords (same as face-target)
  _projectToScreen(e) {
    const t = [], s = this.right - this.left, i = this.top - this.bottom, r = this.left, a = this.bottom;
    for (let n = 0; n < e.length; n++)
      t.push([
        e[n][0] * s + r,
        (1 - e[n][1]) * i + a,
        e[n][2] * s
      ]);
    return t;
  }
  _cloneLandmarks(e) {
    return e.map((t) => [t[0], t[1], t[2]]);
  }
  // Negate Z: converts MediaPipe screen-depth convention → OpenCV right-handed convention
  _changeHandedness(e) {
    for (const t of e) t[2] *= -1;
  }
  _moveAndRescaleZ(e, t, s) {
    for (const i of s)
      i[2] = (i[2] - e + this.near) / t;
  }
  _unprojectScreen(e) {
    for (const t of e)
      t[0] = t[0] * t[2] / this.near, t[1] = t[1] * t[2] / this.near;
  }
}
const v = 1e-3, V = 1, H = 33;
class b {
  constructor({ onUpdate: e = null, filterMinCF: t = null, filterBeta: s = null }) {
    this.estimator = null, this.lastEstimateResult = null, this.filterMinCF = t === null ? v : t, this.filterBeta = s === null ? V : s, this.onUpdate = e, this.flipPose = !1, this.processingVideo = !1, this.landmarkFilters = [];
    for (let i = 0; i < H; i++)
      this.landmarkFilters[i] = new w({ minCutOff: this.filterMinCF, beta: this.filterBeta });
    this.poseMatrixFilter = new w({ minCutOff: this.filterMinCF, beta: this.filterBeta }), this.poseScaleFilter = new w({ minCutOff: this.filterMinCF, beta: this.filterBeta });
  }
  async setup(e) {
    this.flipPose = e, await R(), this.poseMeshHelper = new C(), await this.poseMeshHelper.init();
  }
  // Called after video dimensions are known (and after setup() so OpenCV is ready)
  onInputResized(e) {
    this.estimator && this.estimator.release(), this.estimator = new S(e);
  }
  getCameraParams() {
    return this.estimator.getCameraParams();
  }
  async dummyRun(e) {
    await this.poseMeshHelper.detect(e);
  }
  processVideo(e) {
    if (this.processingVideo) return;
    this.processingVideo = !0;
    const t = async () => {
      try {
        const s = await this.poseMeshHelper.detect(e);
        if (s !== void 0)
          if (s === null) {
            this.lastEstimateResult = null, this.onUpdate && this.onUpdate({ hasPose: !1 });
            for (let i = 0; i < this.landmarkFilters.length; i++)
              this.landmarkFilters[i].reset();
            this.poseMatrixFilter.reset(), this.poseScaleFilter.reset();
          } else {
            const i = s.landmarks.map((a) => [a.x, a.y, a.z]);
            if (this.flipPose)
              for (const a of i) a[0] = 1 - a[0];
            const r = this.estimator.estimate(i);
            if (r) {
              if (this.lastEstimateResult === null)
                this.lastEstimateResult = r;
              else {
                const a = Date.now(), n = [];
                for (let l = 0; l < r.metricLandmarks.length; l++)
                  n[l] = this.landmarkFilters[l].filter(a, r.metricLandmarks[l]);
                const d = this.poseMatrixFilter.filter(a, r.poseMatrix), c = this.poseScaleFilter.filter(a, [r.poseScale]);
                this.lastEstimateResult = {
                  metricLandmarks: n,
                  poseMatrix: d,
                  poseScale: c[0]
                };
              }
              this.onUpdate && this.onUpdate({ hasPose: !0, estimateResult: this.lastEstimateResult });
            }
          }
      } catch (s) {
        console.warn("Pose processing error (frame skipped):", s);
      }
      this.processingVideo && window.requestAnimationFrame(t);
    };
    window.requestAnimationFrame(t);
  }
  stopProcessVideo() {
    this.processingVideo = !1;
  }
  // Returns a 16-element row-major matrix: poseMatrix × scale_translate(t)
  // Scale is fixed at 1 so the rendered object does not grow/shrink with distance.
  _buildMatrix(e) {
    if (!this.lastEstimateResult || !e) return null;
    const { poseMatrix: t } = this.lastEstimateResult;
    return [
      t[0],
      t[1],
      t[2],
      t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3],
      t[4],
      t[5],
      t[6],
      t[4] * e[0] + t[5] * e[1] + t[6] * e[2] + t[7],
      t[8],
      t[9],
      t[10],
      t[8] * e[0] + t[9] * e[1] + t[10] * e[2] + t[11],
      t[12],
      t[13],
      t[14],
      t[12] * e[0] + t[13] * e[1] + t[14] * e[2] + t[15]
    ];
  }
  // Matches face-target's getLandmarkMatrix formula exactly.
  getLandmarkMatrix(e) {
    return this.lastEstimateResult ? this._buildMatrix(this.lastEstimateResult.metricLandmarks[e]) : null;
  }
  // Matrix positioned at the midpoint between two landmarks (e.g. shoulders 11 & 12).
  getMidpointMatrix(e, t) {
    if (!this.lastEstimateResult) return null;
    const { metricLandmarks: s } = this.lastEstimateResult, i = s[e], r = s[t];
    return !i || !r ? null : this._buildMatrix([(i[0] + r[0]) / 2, (i[1] + r[1]) / 2, (i[2] + r[2]) / 2]);
  }
  // Anchor matrix for the shoulder midpoint.
  //   Position: back-projected 2D shoulder midpoint at a stable depth derived
  //             from the apparent 2D shoulder width — avoids the 3D Z estimate
  //             which blows up when one shoulder comes forward during torso rotation.
  //   Rotation: roll only, taken from the 2D shoulder line so the necklace
  //             tilts with the body; pitch/yaw stay identity so it keeps
  //             facing the camera.
  //   Scale:    apparent 2D shoulder width drives depth, so the necklace grows/
  //             shrinks naturally as you move closer/farther.  Torso rotation
  //             also reduces apparent shoulder width, behaving like moving away.
  getBodyFrameMatrix() {
    if (!this.lastEstimateResult) return null;
    const { metricLandmarks: e } = this.lastEstimateResult, t = e[11], s = e[12];
    if (!t || !s || t[2] === 0 || s[2] === 0) return null;
    const i = t[0] / -t[2], r = t[1] / -t[2], a = s[0] / -s[2], n = s[1] / -s[2], d = (i + a) / 2, c = (r + n) / 2, l = Math.sqrt((a - i) ** 2 + (n - r) ** 2);
    if (l === 0 || !Number.isFinite(l)) return null;
    const f = Math.min(-1 / l, -1.2), u = d * -f, p = c * -f;
    let h = Math.atan2(r - n, i - a);
    h > Math.PI / 2 ? h -= Math.PI : h < -Math.PI / 2 && (h += Math.PI);
    const g = Math.cos(h), m = Math.sin(h);
    return [
      g,
      -m,
      0,
      u,
      m,
      g,
      0,
      p,
      0,
      0,
      1,
      f,
      0,
      0,
      0,
      1
    ];
  }
}
export {
  b as Controller,
  C as PoseMeshHelper
};
